import type { UpdateCartProduct } from '@repo/api/web/models'

import { useCartModule } from './useCartModule'

export const useCart = () => {
  const { support: authSupport } = useAuth()
  const { store, service, support } = useCartModule()

  function checkInCart(productId?: number) {
    return productId ? support.checkInCart(productId) : false
  }

  function getItem(productId?: number) {
    return productId
      ? store.cart?.items?.find(item => item.id === productId)
      : null
  }

  async function addToCart(productId: number, increase?: number) {
    if (!authSupport.checkAuth()) {
      await authSupport.createAnonimSession()
    }

    const item = getItem(productId)
    await service.updateCart({
      products: [
        {
          productId,
          amount: item ? (item.amount || 1) + (increase || 1) : 1,
        } as UpdateCartProduct,
      ],
    } as any)

    await support.loadCart(true)
  }

  async function removeFromCart(productId: number, decrease?: number) {
    if (!authSupport.checkAuth()) {
      return
    }

    const item = getItem(productId)
    if (!item) return

    await service.updateCart({
      products: [
        {
          productId,
          amount: decrease
            ? (item.amount || 1) - decrease
            : 0 /* 0 обрабатывается api как удаление */,
        } as UpdateCartProduct,
      ],
    } as any)

    await support.loadCart(true)
  }

  async function clearCart() {
    if (!authSupport.checkAuth()) {
      return
    }

    await service.clearCart()

    await support.loadCart(true)
  }

  async function toggleNotify(productId: number) {
    if (!authSupport.checkAuth()) {
      return
    }

    await support.toggleNotify(productId)
  }

  return {
    checkInCart,
    getItem,
    addToCart,
    removeFromCart,
    clearCart,
    toggleNotify,
  }
}
